import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AddonsServices from '../services/AddonsServices';
import useAsync from '../hooks/useAsync';
import TogelButtonForStatus from './TogelButton/TogalButtonForStatus';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import AddonsUpdate from './Update Model/UpdateAddons';
import * as XLSX from 'xlsx';

Modal.setAppElement('#root');

function AddonsList() {
  const { data, error, isLoading, run } = useAsync(AddonsServices.getAddons);

  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const handleEditDetails = (addons) => {
    setSelectedEdit(addons);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (addons) => {
    setSelectedEdit(addons);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const formatDateTime = (isoString) => {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if needed
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-11) and pad with leading zero
  const year = date.getFullYear(); // Get full year
  return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
};


  // Filtered data based on search query
  const filteredData = data?.data?.filter(addons =>
    addons.title.toLowerCase().includes(searchQuery.toLowerCase())
  );


  const generateExcel = () => {
    const filteredData = data?.data?.map(addons => ({
      title: addons?.title,
      price: addons?.price,
      image: process.env.REACT_APP_URL + addons?.image,
      date: formatDateTime(addons?.createdAt),
      status: addons?.status,
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'AddonsData');
    XLSX.writeFile(wb, 'addons_data.xlsx');
  };

  return (
    <>
      <div className="right_col" role="main">
        <div className="title-box">
          <h2>
          Addons List <span className="badge bg-orange">{filteredData?.length || 0}</span>
          </h2>
          <div className="container-box-top-header-right">
            <Link className="round-add-btn" to="/add-addons">
              <img src="img/plus.svg" alt="Add Addons" />
            </Link>
            <button className="excel-btn" style={{ marginTop: 20 }} onClick={generateExcel}>
              <img src="img/excel.svg" alt="Download Excel" />
              Download
            </button>
          </div>
        </div>
        <div className="container-box px-0 pt-2">
          <div className="container-box-top-header px-4" style={{ marginTop: 20 }}>
            <div className="container-box-top-header-left-2">
              <input
                type="search"
                name="search"
                placeholder="Search "
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button className="search-btn">Search</button>
            </div>
          </div>
          <div className="container-box-inner">
            <table id="example" className="table table-striped" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>IMAGE</th>
                  <th>TITLE</th>
                  <th>PRICE</th>
                  <th>MINUTES</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {filteredData?.map((addons, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    
                    <td>
                      <div className="product-img">
                        <img
                          src={process.env.REACT_APP_URL + addons?.image}
                          alt=""
                          style={{ height: '70px', width: '70px', objectFit: 'contain' }}
                        />
                      </div>
                    </td>
                    <td>{addons?.title}</td>
                    <td>{addons?.price}</td>
                    <td>{addons?.minutes}</td>
                    <td className="status-toggle">
                      <TogelButtonForStatus data={addons} page="Addons" onSuccess={() => run()} />
                    </td>
                    <td>
                      <div className="action_toggle_outer">
                        <button className="action_toggle" onClick={() => toggleActionMenu(i)}>
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === i && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li>
                                <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                  <i className="fa fa-close" />
                                </button>
                              </li>
                              <li>
                                <button className="edit" onClick={() => handleEditDetails(addons)}>Edit</button>
                              </li>
                              <li>
                                <button className="reject" onClick={() => handleDelete(addons)}>Delete</button>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          contentLabel="User Details"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <AddonsUpdate addons={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
        </Modal>
        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="Addons" closeModal={closeDeleteModal} onSuccess={run} />
        </Modal>
      </div>
    </>
  );
}

export default AddonsList;
